import React, { useEffect } from "react";
import { Book, MicrosoftExcelLogo } from "phosphor-react";
import styled from "styled-components";

// Context
import {
  ACTIONS,
  useExcelFileUploadContext,
} from "../../../context/ExcelFileUploadProvider";
import {
  useModalHistory,
  ACTIONS as MODAL_ACTIONS,
} from "../../../context/ModalHistoryProvider";

// Components
import { InputFile } from "../../Controls/InputFile";
import { UploadFileButton } from "../../Controls/UploadFileButton";
import StackStyle from "../../Styled/Stack.style";
import Modal from "../../Modal/Modal";
import MatchHeadersModal from "../../MatchHeaders/MatchHeadersModal";
import Select from "../../Inputs/Select";
import QueueStyle from "../../Styled/Queue.style";

// Utils
import useType from "../../../utils/hooks/useType";
import {
  convertWorkSheetToJson,
  readFile,
} from "../../../utils/helpers/excelToJson";
import colors from "../../../utils/constants/COLORS";
import { DEAL_TYPES } from "../../../utils/constants/SYSTEM";

export default function ListPriceDealsUploadModal() {
  const [{ excelWorkBook, excelSheet }, dispatch] = useExcelFileUploadContext();
  const [exceedLimitError, setExceedLimitError] = useType("boolean", false);

  const [, dispatchModalHistory] = useModalHistory();

  const pushEnd = (modal) =>
    dispatchModalHistory({
      type: MODAL_ACTIONS.PUSH_END,
      payload: { value: modal },
    });

  // Clear workbook content
  useEffect(() => {
    return () => {
      dispatch({
        type: ACTIONS.SET_EXCEL_WORKBOOK,
        payload: { value: {} },
      });
      
    }
  }, [dispatch]);

  return (
    <Modal title="Please select a list price deal excel file to upload">
      <StackStyle>
        <QueueStyle>
          <InputFile
            excelWorkBook={excelWorkBook}
            setExcelWorkSheetName={(value) => dispatch({type: ACTIONS.SET_EXCEL_SHEET, payload: {value}})}
            setExceedLimitError={setExceedLimitError}
            readFile={readFile}
            dispatch={dispatch}
            suffix={
              <MicrosoftExcelLogo size={18} weight="fill" color="green" />
            }
          />
        </QueueStyle>
        <br />
        {Object.keys(excelWorkBook).length > 0 && (
          <Select
            defaultValue="Select sheet name"
            value={excelSheet}
            options={excelWorkBook.SheetNames}
            handleChange={(value) => dispatch({ type: ACTIONS.SET_EXCEL_SHEET, payload: { value } })}
            prefix={
              <Book
                size={18}
                weight="thin"
                color={colors.informational.color}
              />
            }
          />
        )}
        <br />
        {exceedLimitError && (
          <ErrorStyle>Exceeded row/sheet upload limit</ErrorStyle>
        )}
        <UploadFileButton
          onClick={() => {
            dispatch({
              type: ACTIONS.SET_EXCEL_JSON,
              payload: {
                value: convertWorkSheetToJson(
                  excelWorkBook.Sheets[excelSheet]
                ),
              },
            });

            pushEnd(<MatchHeadersModal scope={DEAL_TYPES.LIST_PRICE} />);
          }}
          disabled={!excelSheet}
        />
      </StackStyle>
    </Modal>
  );
}

const ErrorStyle = styled.span`
  color: red;
  font-weight: bold;
`;